import React, { useEffect, useState } from 'react'
import { ScientificDayInterface, DefaultScientificDayInterface, ShowScientificDayContext, modalType } from './types';
import { useDispatch } from 'react-redux';
import { getScientificDaysApi } from '../../redux/scientificday/scientificDayApiCalls';
import DataScientificDay from './DataScientificDay';
import AddScientificDayModal from './AddScientificDayModal';
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import SuccessMsg from '../../Messages/SuccessMsg';
import EditScientificDayModal from './EditScientificDayModal';
import DeleteScientificDayModal from './DeleteScientificDayModal';
import DeletePhotoScientificDay from './photos/DeletePhotoScientificDay';

const ShowScientificDay:React.FC = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [showAddScientificDayModal, setShowAddScientificDayModal] = useState(false);
  const [showEditScientificDayModal, setShowEditScientificDayModal] = useState(false);
  const [showDeleteScientificDayModal, setShowDeleteScientificDayModal] = useState(false);
  const [selectedScientificDay, setSelectedScientificDay] = useState<ScientificDayInterface>(DefaultScientificDayInterface)
  const [selectedModal, setSelectedModal] = useState("")
  const [showDeleteScientificDayPhotoModal, setShowDeleteScientificDayPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState("")

  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getScientificDaysApi())
    }
    fetchAPIs()
  }, [dispatch])

  const navigate = useNavigate()

  return (
    <ShowScientificDayContext.Provider value={{ 
      showSuccessMsg, setShowSuccessMsg,
      showAddScientificDayModal, setShowAddScientificDayModal,
      showEditScientificDayModal, setShowEditScientificDayModal,
      showDeleteScientificDayModal, setShowDeleteScientificDayModal,
      selectedScientificDay, setSelectedScientificDay,
      selectedModal, setSelectedModal,
      showDeleteScientificDayPhotoModal, setShowDeleteScientificDayPhotoModal,
      selectedPhoto, setSelectedPhoto,
    }}> 
      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/>
      <div className="flex justify-start gap-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
        <button className="p-2 rounded bg-main text-white" onClick={() => {
            setSelectedModal(modalType.AddModal)
            setShowAddScientificDayModal(!showAddScientificDayModal)
          }}>
          <FaPlus />
        </button>
      </div>
      <AddScientificDayModal modal={showAddScientificDayModal} toggle={() => setShowAddScientificDayModal(!showAddScientificDayModal)} />
      {selectedScientificDay?.theme && 
        <EditScientificDayModal modal={showEditScientificDayModal} toggle={() => setShowEditScientificDayModal(!showEditScientificDayModal)} />
      }
      {selectedScientificDay?.theme && 
        <DeleteScientificDayModal modal={showDeleteScientificDayModal} toggle={() => setShowDeleteScientificDayModal(!showDeleteScientificDayModal)} />
      }
      <DataScientificDay />
      {
        showDeleteScientificDayPhotoModal && 
        <DeletePhotoScientificDay modal={showDeleteScientificDayPhotoModal}  toggle={() => setShowDeleteScientificDayPhotoModal(!showDeleteScientificDayPhotoModal)}/>
      }

    </ShowScientificDayContext.Provider>
  )
}

export default ShowScientificDay

